import React, { useEffect, useState } from 'react';
import Fab from '@mui/material/Fab';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import Popover from '@mui/material/Popover';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import { useSelector } from 'react-redux';
import isEmpty from '../../../is-empty';

function focusField(labelText) {
  const clean = labelText.replace(/\s*\(.*\)$/, '').trim();

  // Try to find by label text match
  const labels = document.querySelectorAll('label');
  for (const label of labels) {
    // Strip asterisks, non-breaking spaces, and extra whitespace from label text
    const text = label.textContent.replace(/[\s\u00a0]*\*+$/, '').trim();
    if (text === clean || text === labelText) {
      // Walk up to the widest relevant container — Autocomplete wraps FormControl
      const container = label.closest('.MuiAutocomplete-root')
        || label.closest('.MuiFormControl-root')
        || label.parentElement;
      const input = container?.querySelector('input, textarea, select, [role="combobox"]');
      if (input) {
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => input.focus(), 300);
        return;
      }
    }
  }

  // Fallback: find field with matching error state (MUI error class)
  const errorFields = document.querySelectorAll('.Mui-error input, .Mui-error textarea, .Mui-error select, .Mui-error [role="combobox"]');
  if (errorFields.length > 0) {
    errorFields[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(() => errorFields[0].focus(), 300);
  }
}

export default function ErrorFAB(props) {
  const errors = useSelector(state => state.errors.list);
  const [dialogOpen, setDialogOpen] = useState(false);

  // Hide the FAB while a MUI Dialog is mounted — dialogs should surface their own errors inline.
  useEffect(() => {
    if (typeof document === 'undefined') return;
    const check = () => setDialogOpen(document.querySelector('.MuiDialog-root') != null);
    check();
    const observer = new MutationObserver(check);
    observer.observe(document.body, { childList: true, subtree: false });
    return () => observer.disconnect();
  }, []);

  const display = (isEmpty(errors) || dialogOpen) ? 'none' : 'block';

  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setTimeout(() => {
        setAnchorEl(null);
    }, 5000);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleErrorClick = (key) => {
    setAnchorEl(null);
    focusField(key);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const button = () => {
    return (
        <div>
          <Fab color="error" variant='circular' aria-label="Errors found" {...props}
               sx={{
                  zIndex: 1000,
                  position: 'fixed',
                  bottom: {xs: 85, md: 40},
                  right: 40,
                  display: display,
               }}
               onClick={handleClick}
          >
            <ErrorRoundedIcon fontSize="large" />
          </Fab>
          <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
              }}
            >
            <List sx={{ width: 500 }}>
                {Object.keys(errors).map((key, index) => (
                <ListItemButton key={index} onClick={() => handleErrorClick(key)}>
                    <strong>{key}:</strong>&nbsp;{errors[key]}
                </ListItemButton>
                ))}
            </List>
          </Popover>
        </div>
      );
  }

  if (!isEmpty(errors) && !dialogOpen) {
    return button();
  }else
    return null;

}